<!--
 * @Description: 新闻详情
 * @Author: mileS
 * @Date: 2019-08-07 10:14:46
 * @LastEditTime: 2020-06-10 16:39:24
 * @LastEditors: Please set LastEditors
 -->
<template>
  <div class="news-detail-container">
    <BreadCrumb :path="'/about_us/news_center/list'"/>
    <div class="news-detail-wrapper">
      <div class="content">
        <RichText :rich-text="newsDetail[id]"/>
      </div>
    </div>
  </div>
</template>

<script>
import { newsDetail } from './assets/data'
import RichText from './components/RichText'
import BreadCrumb from './components/BreadCrumb'

export default {
  components: { RichText, BreadCrumb },
  data () {
    return {
      newsDetail,
      id: '1' // 新闻id
    }
  },
  created () {
  },
  mounted () {
    this.id = this.$route.query.id
  },
  methods: {
  }
}
</script>

<style scoped lang="scss">
.news-detail-container {
  font-size: 16px;
  margin: 80px 0 0 0;
  text-align: left;
  background-color: #F8F9FD;
  padding-bottom: 50px;
  .news-detail-wrapper{
    margin: 0 auto;
    width: 1106px;
    .content{
      padding: 50px;
      background: #ffffff;
      .info{
        margin: 20px 0 40px 0;
        text-align: center;
        color:rgba(153,153,153,1);
        line-height:26px;
        .author{
          margin-right: 160px;
        }
      }
      .title{
        text-align: center;
        font-size:32px;
        font-weight:600;
        color:rgba(40,40,40,1);
        line-height:45px;
      }
    }
  }
}
</style>
